<template>
  <div class="form-row">
    <div class="form-group col-md-6 col-lg-2">
      <label>Buscar</label>
        <input
          class="form-control"
          type="text"
          placeholder="Digite para buscar..."
          v-model="name"
          v-on:keyup.enter="handleFilter"
        />
    </div>

    <div class="form-group col-md-6 col-lg-2">
      <label>Selecione o cliente</label>
        <select
            @change="handleFilter"
            v-model="seller"
            class="form-control"
            name=""
        >
          <option
            v-for="item in listSellers"
            :value="item.id"
            :key="item.id"
            :selected="item.id"
          >
            {{ item.name }} {{ item.selected }}
          </option>
        </select>
    </div>

    <div class="form-group col-md-6 col-lg-2">
      <label>Etapa da transação</label>
        <select
            @change="handleFilter"
            v-model="transactionStepSelected"
            class="form-control"
            name=""
        >
          <option
            v-for="item in transactionStep"
            :value="item.id"
            :key="item.id"
            :selected="item.id"
          >
            {{ item.name }} {{ item.selected }}
          </option>
        </select>
    </div>

    <div class="form-group col-md-6 col-lg-2">
      <label>Últimos cadastros</label>
        <select
            @change="handleFilter"
            v-model="orderBySelected"
            class="form-control"
            name=""
        >
          <option
            v-for="item in orderBy"
            :value="item.id"
            :key="item.id"
            :selected="item.id"
          >
            {{ item.name }} {{ item.selected }}
          </option>
        </select>
    </div>

    <div class="form-group col-md-6 col-lg-2">
      <label>Data inicial/final</label>
      <v-date-picker
        :popover="{ visibility: 'click' }"
        mode="range"
        v-model="date"
        class="flex-grow"
        :columns="$screens({ default: 1, lg: 2 })"
        :max-date="new Date()"
      >
        <!--Custom Input Slot-->
        <input
          id="date"
          slot-scope="{ inputProps, inputEvents, isDragging }"
          :class="[
            `w-full py-2 px-3 ${
              isDragging ? 'form-control' : 'form-control'
            }`
          ]"
          v-bind="inputProps"
          placeholder="00/00/0000"
          v-on="inputEvents"
          readonly="readonly"
        />
      </v-date-picker>
    </div>

    <div class="form-group col-md-6 col-lg-2">
      <button type="button" class="btn bf-btn-search mt-4" @click="handleFilter()">
        <i class="fa fa-search" style="margin: 0;"></i>
      </button>

      <button type="button" class="btn btn-link bf-btn-clear mt-4" @click="clearFields">
        Limpar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderBy: Array,
    transactionStep: Array,
    listSellers: Array
  },
  data () {
    return {
      name: '',
      seller: null,
      orderBySelected: 'first',
      transactionStepSelected: null,
      date: null
    }
  },
  methods: {
    clearFields () {
      this.name = ''
      this.seller = null
      this.orderBySelected = null
      this.transactionStepSelected = null
      this.date = null

      this.handleFilter()
    },
    handleFilter () {
      this.$emit('loadFilterData', {
        name: this.name,
        seller: this.seller,
        transactionStepSelected: this.transactionStepSelected,
        orderBySelected: this.orderBySelected,
        date: this.date
      })
    }
  },
  computed: {
  },
  watch: {
    date () {
      this.handleFilter()
    }
  }
}
</script>

<style lang="scss" scoped>
.bf-btn-search {
  background: #1C56E0;
  color: #FFF;
  width: 40px;
  height: 40px;
}

.bf-btn-clear {
  color: #1C56E0;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/order/OrderFilter.vue